import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { OverlayService } from '@nucleus/ui-common';
import { BrowserModule } from '@angular/platform-browser';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-glass-panel',
    imports: [BrowserModule],
    templateUrl: './glass-panel.component.html',
    styleUrl: './glass-panel.component.css'
})
export class GlassPanelComponent implements OnInit , OnDestroy{

  constructor(private overlayService: OverlayService) { }

  _showing: boolean = false;
  subs : Subscription = new Subscription();

  ngOnInit(): void {
    this.subs = this.overlayService.showing.subscribe( b => this._showing = b);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public showing() : boolean {
    return this._showing;
  }
}
